import { FC, ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { SlideNavigationItemsWrapper, TitleGradient, WrapperSlider } from "./styles";
import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { AppTester } from "supporting";
import { useRouteMatch } from "react-router-dom";

const PERCENT_OF_WRAPPER_WIDTH = 90;

export const ScrollableSlideNavigationItems:
    FC<{ children: ReactNode, overflowX?: boolean, paymentSuccess?: boolean, isPayment?: boolean, isDesigner?: boolean, stretch?: boolean, fullWidth?: boolean, smallTab?: boolean, isTitle?: boolean }>
    = ({ children, overflowX, isPayment, paymentSuccess, isDesigner, stretch, fullWidth, smallTab, isTitle }) => {

        const [isMouseDown, setIsMouseDown] = useState(false);
        const [startX, setStartX] = useState(0);
        const [startY, setStartY] = useState(0);
        const [scrollLeft, setScrollLeft] = useState(0);
        const [scrollTop, setScrollTop] = useState(0);
        const [showSliderGradient, setShowSliderGradient] = useState(false);
        const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
        const containerRef = useRef<HTMLDivElement>(null);
        const isHseDeziiign = AppTester.isHSEDesign();
        const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
        
        const isCGrave = AppTester.isCGRAVE();

        const showTabGradient = useMemo(
            () => (isTitle && isMobile && containerRef?.current && !isCGrave && ((containerRef.current?.clientWidth * 100) / window.innerWidth) > PERCENT_OF_WRAPPER_WIDTH
            )
            , [isTitle, containerRef.current, isMobile, isCGrave]
        )

        const handleMouseDown = (e: any) => {

            if (!containerRef.current) return

            setIsMouseDown(true);
            setStartX(e.pageX);
            setStartY(e.pageY);
            setScrollLeft(containerRef.current.scrollLeft);
            setScrollTop(containerRef.current.scrollTop);
        };

        const handleMouseLeave = () => {
            setIsMouseDown(false);
        };

        const handleMouseUp = () => {
            setIsMouseDown(false);
        };

        const handleMouseMove = (e: any) => {
            if (!isMouseDown) return;
            if (!containerRef.current) return

            const x = e.pageX;
            const y = e.pageY;

            const walkX = (x - startX);
            const walkY = (y - startY);

            containerRef.current.scrollLeft = scrollLeft - walkX;
            containerRef.current.scrollTop = scrollTop - walkY;
        };

        useEffect(() => {
            if (!containerRef?.current) return

            const resizeObserver = new ResizeObserver(() => {
                if (!containerRef?.current) return
                setShowSliderGradient(containerRef?.current?.clientWidth < containerRef?.current?.scrollWidth)
            });

            resizeObserver.observe(containerRef?.current);
            return () => resizeObserver.disconnect(); // clean up
        }, [containerRef]);

        if (isPayment && showSliderGradient) return (
            <WrapperSlider isPayment={isPayment}>
                < SlideNavigationItemsWrapper
                    wrap={(stretch || fullWidth) ? 'wrap' : "nowrap"
                    } wrapMobile={(stretch || fullWidth) ? 'wrap' : "nowrap"} offsetBottomMobile={- 4}
                    ref={containerRef}
                    onMouseDown={isDesigner ? handleMouseDown : undefined} isPayment={isPayment} isPaymentSuccess={paymentSuccess}
                    onMouseLeave={isDesigner ? handleMouseLeave : undefined}
                    onMouseUp={isDesigner ? handleMouseUp : undefined}
                    onMouseMove={isDesigner ? handleMouseMove : undefined}
                    overflowX={overflowX} isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} /*gradientVisible={showTabGradient}*/ >
                    {children}
                    {!isTeamOrCoursePage && showTabGradient && <TitleGradient />}
                </SlideNavigationItemsWrapper >
            </WrapperSlider >
        )

        return < SlideNavigationItemsWrapper
            wrap={(stretch || fullWidth) ? 'wrap' : "nowrap"
            } wrapMobile={(stretch || fullWidth) ? 'wrap' : "nowrap"} offsetBottomMobile={- 4}
            ref={containerRef}
            onMouseDown={isDesigner ? handleMouseDown : undefined} isPayment={isPayment} isPaymentSuccess={paymentSuccess}
            onMouseLeave={isDesigner ? handleMouseLeave : undefined}
            onMouseUp={isDesigner ? handleMouseUp : undefined}
            onMouseMove={isDesigner ? handleMouseMove : undefined}
            isHseDeziiign={isHseDeziiign}
            overflowX={overflowX} isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} /*gradientVisible={showTabGradient}*/ >
            {children}
            {!isTeamOrCoursePage && showTabGradient && <TitleGradient />}
        </SlideNavigationItemsWrapper >

    }

import { FC, ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { SlideNavigationItemsWrapper, TitleGradient, WrapperSlider } from "./styles";
import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { AppTester } from "supporting";
import { useRouteMatch } from "react-router-dom";

const PERCENT_OF_WRAPPER_WIDTH = 90;

export const ScrollableSlideNavigationItems:
    FC<{ children: ReactNode, overflowX?: boolean, paymentSuccess?: boolean, isPayment?: boolean, isDesigner?: boolean, stretch?: boolean, fullWidth?: boolean, smallTab?: boolean, isTitle?: boolean }>
    = ({ children, overflowX, isPayment, paymentSuccess, isDesigner, stretch, fullWidth, smallTab, isTitle }) => {

        const [isMouseDown, setIsMouseDown] = useState(false);
        const [startX, setStartX] = useState(0);
        const [startY, setStartY] = useState(0);
        const [scrollLeft, setScrollLeft] = useState(0);
        const [scrollTop, setScrollTop] = useState(0);
        const [showSliderGradient, setShowSliderGradient] = useState(false);
        const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
        const containerRef = useRef<HTMLDivElement>(null);
        const isHseDeziiign = AppTester.isHSEDesign();
        const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
        
        const isCGrave = AppTester.isCGRAVE();

        const showTabGradient = useMemo(
            () => (isTitle && isMobile && containerRef?.current && !isCGrave && ((containerRef.current?.clientWidth * 100) / window.innerWidth) > PERCENT_OF_WRAPPER_WIDTH
            )
            , [isTitle, containerRef.current, isMobile, isCGrave]
        )

        const handleMouseDown = (e: any) => {

            if (!containerRef.current) return

            setIsMouseDown(true);
            setStartX(e.pageX);
            setStartY(e.pageY);
            setScrollLeft(containerRef.current.scrollLeft);
            setScrollTop(containerRef.current.scrollTop);
        };

        const handleMouseLeave = () => {
            setIsMouseDown(false);
        };

        const handleMouseUp = () => {
            setIsMouseDown(false);
        };

        const handleMouseMove = (e: any) => {
            if (!isMouseDown) return;
            if (!containerRef.current) return

            const x = e.pageX;
            const y = e.pageY;

            const walkX = (x - startX);
            const walkY = (y - startY);

            containerRef.current.scrollLeft = scrollLeft - walkX;
            containerRef.current.scrollTop = scrollTop - walkY;
        };

        useEffect(() => {
            if (!containerRef?.current) return

            const resizeObserver = new ResizeObserver(() => {
                if (!containerRef?.current) return
                setShowSliderGradient(containerRef?.current?.clientWidth < containerRef?.current?.scrollWidth)
            });

            resizeObserver.observe(containerRef?.current);
            return () => resizeObserver.disconnect(); // clean up
        }, [containerRef]);

        if (isPayment && showSliderGradient) return (
            <WrapperSlider isPayment={isPayment}>
                < SlideNavigationItemsWrapper
                    wrap={(stretch || fullWidth) ? 'wrap' : "nowrap"
                    } wrapMobile={(stretch || fullWidth) ? 'wrap' : "nowrap"} offsetBottomMobile={- 4}
                    ref={containerRef}
                    onMouseDown={isDesigner ? handleMouseDown : undefined} isPayment={isPayment} isPaymentSuccess={paymentSuccess}
                    onMouseLeave={isDesigner ? handleMouseLeave : undefined}
                    onMouseUp={isDesigner ? handleMouseUp : undefined}
                    onMouseMove={isDesigner ? handleMouseMove : undefined}
                    overflowX={overflowX} isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} /*gradientVisible={showTabGradient}*/ >
                    {children}
                    {!isTeamOrCoursePage && showTabGradient && <TitleGradient />}
                </SlideNavigationItemsWrapper >
            </WrapperSlider >
        )

        return < SlideNavigationItemsWrapper
            wrap={(stretch || fullWidth) ? 'wrap' : "nowrap"
            } wrapMobile={(stretch || fullWidth) ? 'wrap' : "nowrap"} offsetBottomMobile={- 4}
            ref={containerRef}
            onMouseDown={isDesigner ? handleMouseDown : undefined} isPayment={isPayment} isPaymentSuccess={paymentSuccess}
            onMouseLeave={isDesigner ? handleMouseLeave : undefined}
            onMouseUp={isDesigner ? handleMouseUp : undefined}
            onMouseMove={isDesigner ? handleMouseMove : undefined}
            isHseDeziiign={isHseDeziiign}
            overflowX={overflowX} isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} /*gradientVisible={showTabGradient}*/ >
            {children}
            {!isTeamOrCoursePage && showTabGradient && <TitleGradient />}
        </SlideNavigationItemsWrapper >

    }

